<!--Footer Starts-->
<footer>
    <div class="container-fluid text-center" style="padding-top: 1rem; padding-bottom: 1rem;">
        Copyright &copy; {{currentDate | date: 'yyyy'}} <a id="smartieLink" href="https://www.smartiepants.com">Smartie
            Pants</a>, All rights reserved.
    </div>
</footer>
<!--Footer Ends-->